'use strict';

/*global blockElement*/
/*global unBlockElement*/
/*global createObjectCallBack*/
/*global compareDates*/
/*global validateInputs*/
/*global addRow*/
/*global replaceAttrKey*/
/*global initialize*/
/*global services*/

function MyProfile() {

    this.init();
}

MyProfile.prototype = $.extend({}, {
    construtor: 'MyProfile',

    //**************************************************************************

    registerCallbacks: function registerCallbacks() {
        var _this = this;

        $('body').off('click', '.storno-reservation');
        $('body').on('click', '.storno-reservation', function clickStornoReservationClb() {
            _this.stornoReservation($(this).data('order_id'));

            return false;
        });

        $('body').off('click', '.repeat-reservation');
        $('body').on('click', '.repeat-reservation', function clickRepeatReservationClb() {
            _this.repeatReservation($(this).data('order_id'));

            return false;
        });

        $('body').off('keyup', '.reservation-repeat-modal input');
        $('body').on('keyup', '.reservation-repeat-modal input', function reseravationFormKeyUpClb() {
            _this.preValidateFromRepeatReservation();
        });

        $('body').off('change', '.reservation-repeat-modal input, .reservation-repeat-modal select');
        $('body').on('change', '.reservation-repeat-modal input, .reservation-repeat-modal select', function reseravationFormChangeClb() {
            _this.preValidateFromRepeatReservation();
        });

        $('body').off('click', '.add-setting-table-row');
        $('body').on('click', '.add-setting-table-row', function addSettingTableRowClb() {
            _this.addSettingTableRow($(this));

            return false;
        });

        return _this;
    },

    //**************************************************************************

    confirmStornoReservation: function confirmStornoReservation(orderId) {
        var _this = this;

        var modal = services.get('confirm');

        modal.block();
        $.getCORS(services.get('configurations').param('DomainURL') + '/?action=my-profile&method=js_storno_reservation&step=2&id=' + orderId, function (res) {
            modal.unBlock();
            try {
                res = JSON.parse(res);
                if (res.msg === 'SUCCESS') {
                    modal.close();
                    services.get('window').redirectTo(res.data.redirect_url);
                } else {
                    services.get('development').viewSiteErrorMsg(res);
                }
            } catch(e) {
                services.get('development').viewSiteErrorMsg(res, e);
            }
        });

        return _this;
    },

    rejectStornoReservation: function rejectStornoReservation() {
        var _this = this;

        var modal = services.get('confirm');
        modal.close();

        return _this;
    },

    stornoReservation: function stornoReservation(orderId) {
        var _this = this;

        var modal = services.get('confirm');
        modal.empty().open({
            title: services.get('translator').trans('StornoReservation'),
            modalClass: 'reservation-storno-modal',
            headerClass: 'bg-primary',
            height: 'auto',
            width: 'md',
            form: true,
            confirmBtnTitle: services.get('translator').trans('ConfirmStornoReservation'),
            rejectBtnTitle: services.get('translator').trans('RejectStornoReservation'),
            confirmCallback: createObjectCallBack(_this, 'confirmStornoReservation', orderId),
            rejectCallback: createObjectCallBack(_this, 'rejectStornoReservation')
        });

        modal.block();
        $.getCORS(services.get('configurations').param('DomainURL') + '/?action=my-profile&method=js_storno_reservation&id=' + orderId, function (res) {
            modal.unBlock();
            try {
                res = JSON.parse(res);
                if (res.msg === 'SUCCESS') {
                    modal.content(res.data.html);
                    initialize(modal.contentDOM());
                } else {
                    services.get('development').viewSiteErrorMsg(res);
                }
            } catch(e) {
                services.get('development').viewSiteErrorMsg(res, e);
            }
        });

        return _this;
    },

    preValidateFromRepeatReservation: function preValidateFromRepeatReservation() {
        var modal = services.get('modal');
        var $form = modal.contentDOM().find('form');

        //zvalidujeme zadane datumy
        var $dates = $form.find('input[name="date_from"], input[name="date_to"]');
        validateInputs($dates, ['date', 'not_empty']);

        var $windowInterval = $form.find('select[name="window_interval_id"]');
        validateInputs($windowInterval, ['not_empty']);

        if (services.get('configurations').param('ReservationType') === 'CAPACITY') {
            if (services.get('configurations').param('MultiDaysReservation')) {
                var $dateFrom = $form.find('input[name="date_from"]');
                var $dateTo = $form.find('input[name="date_to"]');
                var $dateToFormGroup = $dateTo.closest('.form-group');

                if(!compareDates($dateFrom.val(), $dateTo.val())) {
                    $dateToFormGroup.addClass('has-error');
                }

                if (services.get('configurations').param('ReservationWithouLastDay')) {
                    if (!$dateToFormGroup.hasClass('has-error')) {
                        if($dateFrom.val() === $dateTo.val()) {
                            $dateToFormGroup.addClass('has-error');
                        }
                    }
                }
            }
        }

        return $form.find('.has-error').length === 0;
    },

    submitRepeatReservationForm: function submitRepeatReservationForm() {
        var _this = this;

        if (_this.preValidateFromRepeatReservation()) {
            var modal = services.get('modal');
            modal.block();
            $.postCORS(services.get('configurations').param('DomainURL') + '/?action=my-profile&method=js_repeat_reservation', modal.contentDOM().find('form').serialize(), function (res) {
                modal.unBlock();
                try {
                    res = JSON.parse(res);
                    if (res.msg === 'SUCCESS') {
                        modal.close();
                        services.get('window').redirectTo(services.get('configurations').param('BasketURL'));
                    } else if (res.msg === 'NOT_AVAILABLE') {
                        modal.content(res.data.html);
                        initialize(modal.contentDOM());
                    } else {
                        services.get('development').viewSiteErrorMsg(res);
                    }
                } catch(e) {
                    services.get('development').viewSiteErrorMsg(res, e);
                }
            });
        }

        return _this;
    },

    repeatReservation: function repeatReservation(orderId) {
        var _this = this;

        var modal = services.get('modal');
        modal.empty().open({
            title: services.get('translator').trans('RepeatReservation'),
            modalClass: 'reservation-repeat-modal',
            headerClass: 'bg-primary',
            height: 'auto',
            width: 'md',
            form: true,
            formSubmitBtnClass: 'btn-primary',
            formSubmitBtnTitle: services.get('translator').trans('RepeatReservation'),
            formSubmitCallback: createObjectCallBack(_this, 'submitRepeatReservationForm')
        });

        modal.block();
        $.getCORS(services.get('configurations').param('DomainURL') + '/?action=my-profile&method=js_repeat_reservation&id=' + orderId, function (res) {
            modal.unBlock();
            try {
                res = JSON.parse(res);
                if (res.msg === 'SUCCESS') {
                    modal.content(res.data.html);
                    initialize(modal.contentDOM());
                } else {
                    services.get('development').viewSiteErrorMsg(res);
                }
            } catch(e) {
                services.get('development').viewSiteErrorMsg(res, e);
            }
        });

        return _this;
    },

    addSettingTableRow: function addSettingTableRow($button) {
        var _this = this;

        var key = $button.closest('.setting-table__content').find('.setting-table__content-row').length;
        var $clone = addRow($button, '.setting-table__content-row');
        $clone.find(':checkbox').removeAttr('checked').prop('checked', false);
        $clone.find('.setting-table--checked').removeClass('setting-table--checked');
        $clone.find('input, select, textarea').each(function () {
            replaceAttrKey($(this), 'name', 1, key);
        });

        return _this;
    },

    init: function init() {
        var _this = this;

        _this.registerCallbacks();

        return _this;
    }
});
